// extracted by mini-css-extract-plugin
module.exports = {"footer":"Form-module__footer--376PF","loading":"Form-module__loading--3vMuF"};